import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';

const HeaderSkeleton = () => {
  const buttonStyle = { width: '40%' };

  return (
    <div className="header sticky-top">
      <Container>
        <Row className="align-items-center justify-content-around py-2 py-md-3">
          <Col>
            <SkeletonElement type="label-short" />
            <SkeletonElement type="label" />
          </Col>
          <Col className="d-flex justify-content-end">
            <SkeletonElement type="button" style={buttonStyle} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderSkeleton;
